import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  ProjectList,
  SelectionModalConfirmation,
  ProjectTable,
  EconomicImpactSlider,
} from 'imports/ComponentsImports';

import {
  LoadingDialog,
  AlertDialogOneButton,
  Stepper,
  CountdownTimer,
  PrimaryButton,
  SecondaryButton,
  CancelButton,
  HightlightSoftColor,
  SuccessColor,
  FailureColor,
} from 'imports/DesignImports';

import {
  CheckCircleIcon,
  CancelIcon,
  FullCircleIcon,
  ArrowUpIcon,
  ArrowDownIcon,
} from 'imports/IconsImports';

import {
  CircularProgress,
} from 'material-ui';

const styles = {
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  header: {
    marginLeft: '10px'
  },
  stepperContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '2px #F0F0EF solid',
    fontFamily: 'Lato'
  },
  informationContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '0.5em',
  },
  informationText: {
    marginLeft: '1em',
    maxWidth: '40em',
  },
  legend: {
    display: 'flex',
    alignItems: 'center',
  },
  containerTitle: {
    marginBottom: '1em',
    fontWeight: 'bold',
    marginLeft: '1em',
    display: 'flex',
    alignItems: 'center',
  },
  projectsContainer: {
    flex: '7',
    margin: '0 1em 0 2em',
    display: 'flex',
    flexDirection: 'column',
  },
  sendButton: {
    marginRight: '1em',
  },
  sendButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '2em',
  },
  switchButtonContainer: {
    display: 'flex',
    justifyContent: 'space-evenly',
    margin: '2em',
  }
}

class FiltersView extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: false,
      loading: true,
      projects: [],
      selected: [true, false],
      token: props.cookies.get('token'),
      user: props.cookies.get('user'),
      loadingDialog: false,
      alertDialog: false,
      selectionConfirmation: false,
      alertMessage: '',
      allProjects: [],
      manuallySelectedProjects: [],
      manuallyDiscardedProjects: [],
    }
  }

  componentDidMount() {
    this.getData();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar los proyectos. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    if(this.props.done){
      return(
        <div>
          <h2 style={styles.header}> Portafolio de Proyectos </h2>
          <p style={styles.informationText}>
            Estos son los proyectos que quedaron seleccionados en base al filtro de aporte mínimo en régimen.
          </p>
          <ProjectList
            history={this.props.history}
            shownData={["name", "area", "leader", "economic_impact", "years"]}
            projects={this.state.selectedProjects}
            apiToken={this.state.token}/>
        </div>
      );
    }
    return (
      <div style={styles.pageContainer}>
        <div style={styles.headerContainer}>
          <h2 style={styles.header}> Portafolio de Proyectos </h2>
          <CountdownTimer step="selection" token={this.state.token} company_id={this.state.user.company_id}/>
        </div>
        <div style={styles.stepperContainer}>
          <Stepper step={"selection_economic"}/>
        </div>
        <div style={styles.informationContainer}>
          <div>
            <p style={styles.informationText}>
              Estos son los proyectos para los cuales sus líderes cálcularon el indicador. Ahora deberán aplicar el filtro económico y seleccionar proyectos en base a su aporte mínimo en régimen.
            </p>
          </div>
          <div>
            <EconomicImpactSlider currency={this.state.user.company_currency} handleChange={this.handleEconomicSliderChange}/>
            <p style={styles.legend}>Seleccionado/Descartado manualmente <FullCircleIcon color={HightlightSoftColor} /></p>
          </div>
        </div>
          <div style={styles.projectsContainer}>
            <div style={styles.containerTitle}> <CheckCircleIcon color={SuccessColor}/> PROYECTOS SELECCIONADOS ({this.state.passProjects.length}) </div>
            <ProjectTable
              history={this.props.history}
              headers={["nombre", "area", "implementado", "novedad", "solucion", "beneficio", "aporte"]}
              projects={this.state.passProjects}
              changeData={this.state.changeData}
              manualProjectsOperation={(projects) => this.manualProjectsOperation(projects, 'manuallyDiscardedProjects')}
              currency={this.state.user.company_currency}/>
          </div>
          <div style={styles.switchButtonContainer}>
            <CancelButton style={styles.sendButton}
              onClick={() => {this.changeProjects('dontPass')}}
              label="Descartar proyectos marcados"
              labelPosition="before"
              icon={<ArrowDownIcon />}/>
            <PrimaryButton style={styles.sendButton}
              onClick={() => {this.changeProjects('pass')}}
              label="Seleccionar proyectos marcados"
              labelPosition="after"
              icon={<ArrowUpIcon />}/>
          </div>
          <div style={styles.projectsContainer}>
            <div style={styles.containerTitle}> <CancelIcon color={FailureColor}/> PROYECTOS DESCARTADOS ({this.state.dontPassProjects.length}) </div>
            <ProjectTable
              history={this.props.history}
              headers={["nombre", "area", "implementado", "novedad", "solucion", "beneficio", "aporte"]}
              projects={this.state.dontPassProjects}
              changeData={this.state.changeData}
              manualProjectsOperation={(projects) => this.manualProjectsOperation(projects, 'manuallySelectedProjects')}
              currency={this.state.user.company_currency}/>
            </div>
          <div style={styles.sendButtonContainer}>
            <SecondaryButton style={styles.sendButton}
              onClick={() => this.setState({selectionConfirmation: true, confirm: () => this.selectProjects('save')})}
              label="Guardar Selección"/>
            <PrimaryButton style={styles.sendButton}
              onClick={() => this.setState({selectionConfirmation: true, confirm: () => this.selectProjects('send')})}
              label="Validación de comité"/>
          </div>
        { this.state.loadingDialog ? <LoadingDialog message="Estamos enviando los datos, espera un momento" /> : null }
        { this.state.selectionConfirmation ?
          <SelectionModalConfirmation
            passProjects={this.state.passProjects}
            dontPassProjects={this.state.dontPassProjects}
            cancel={() => this.setState({selectionConfirmation: false})}
            confirm={this.state.confirm}
            /> : null}
        {this.state.alertDialogOneButton ?
        <AlertDialogOneButton
          message={this.state.alertMessage}
          confirm={this.state.confirm}
          title={this.state.alertTitle}
          acceptLabel={this.state.acceptLabel} /> : null}
      </div>
    );
  }

  handleEconomicSliderChange = (value) => {
    var passProjects = this.state.passProjects;
    var dontPassProjects = this.state.dontPassProjects;
    var allProjects = passProjects.concat(dontPassProjects);
    passProjects = passProjects.filter((project) => project.isForced).concat(allProjects.filter((project) => !project.isForced && project.indicator[project.indicator.length - 1].value >= value));
    dontPassProjects = dontPassProjects.filter((project) => project.isForced).concat(allProjects.filter((project) => !project.isForced && project.indicator[project.indicator.length - 1].value < value));
    this.setState({
      economicImpact: value,
      passProjects: passProjects,
      dontPassProjects: dontPassProjects,
    })

  }

  changeProjects = (type) => {
    var passProjects = this.state.passProjects;
    var dontPassProjects = this.state.dontPassProjects;
    if(type === 'dontPass'){
      console.log(dontPassProjects);
      this.state.manuallyDiscardedProjects.forEach((project) => {
        var indexPass = passProjects.indexOf(project);
        if(indexPass >= 0)
          passProjects.splice(indexPass, 1);
        var indexDontPass = dontPassProjects.indexOf(project);
        if(indexDontPass < 0){
          project.isForced = !project.isForced;
          dontPassProjects.push(project);
        }
      });
      this.setState({
        dontPassProjects: dontPassProjects,
        passProjects: passProjects,
        manuallyDiscardedProjects: [],
        changeData: true,
      });
    }
    if(type === 'pass'){
      this.state.manuallySelectedProjects.forEach((project) => {
        var indexDontPass = dontPassProjects.indexOf(project);
        if(indexDontPass >= 0)
          dontPassProjects.splice(indexDontPass, 1);
        var indexPass = passProjects.indexOf(project);
        if(indexPass < 0){
          project.isForced = !project.isForced;
          passProjects.push(project);
        }
      });
      this.setState({
        passProjects: passProjects,
        dontPassProjects: dontPassProjects,
        manuallySelectedProjects: [],
        changeData: true,
      });
    }
  }

  manualProjectsOperation = (projects, key) => {
    this.setState({[key]: [...this.state[key], ...projects], changeData: false});
  }

  getData = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.projectFullInformation)
    .then((response) => {
      let calculatedProjects = response.data.filter((project) => {
        return project.state.length > 0 && project.state[0].state === 'Ficha aprobada';
      });
      let savedPassProjects = response.data.filter((project) => {
        return project.state.length > 0 && project.state[0].state === 'Guardado finalizado';
      });
      let savedDontPassProjects = response.data.filter((project) => {
        return project.state.length > 0 && project.state[0].state === 'Guardado corte económico';
      });
      console.log(calculatedProjects);
      this.setState({
        allProjects: calculatedProjects,
        selectedProjects: response.data.filter((project) => {
          return project.state.length > 0 && project.state.map(state => state.state).includes('Finalizado')
        }),
        passProjects: savedPassProjects.length > 0
        ? savedPassProjects.map((project) => {project.isForced = !project.state.map(state => state.state).includes('Ficha aprobada'); return project})
        : calculatedProjects.map((project) => {project.isForced = false; return project}),
        dontPassProjects: savedDontPassProjects.length > 0
        ? savedDontPassProjects.map((project) => {project.isForced = project.state.map(state => state.state).includes('Ficha aprobada'); return project})
        : [],
        error: false,
        loading: false,
      });
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        error: true,
        loading: false
      });
    });
  }

  selectProjects = (type) => {
    this.setState({
      loadingDialog: true,
      alertDialog: false,
      selectionConfirmation: false,
    });

    let data = {
      selectedProjects: this.state.passProjects,
      notSelectedProjects: this.state.dontPassProjects,
    };
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.post(routes.economicSelection(this.state.user.company_id, type), data)
    .then((responses) => {
      this.setState({
        loadingDialog: false,
        alertDialogOneButton: true,
        alertTitle: type === 'send' ? '¡Muy bien!' : 'Tu selección ha sido guardada con éxito',
        alertMessage: type === 'send' ? 'Tu selección de proyectos para medir i3 ha sido finalizada con éxito.'
        : 'Esto no significa que has finalizado la etapa de selección económica. Esta es la propuesta de los proyectos que serán parte del i3. Para finalizar la etapa debes juntarte con el comité de gerentes, tomar una decisión final, y apretar el botón \'Enviar Selección\'',
        acceptLabel: 'Aceptar',
        confirm: type === 'send' ? () => this.props.history.push('/dashboard/summary') : () => this.setState({alertDialogOneButton: false}),
      });
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        loadingDialog: false,
        alertDialogOneButton: true,
        alertTitle: '¡Error!',
        acceptLabel: 'Aceptar',
        alertMessage: 'Hubo un error con la selección, intente nuevamente',
        confirm: () => this.setState({alertDialogOneButton: false}),
      });
    });
    if(type === 'send'){
      connection.patch(routes.nextStage(this.state.user.company_id))
      .then((response) => {
        this.props.cookies.set('current_stage', JSON.stringify(response.data), { path: '/' });
      })
      .catch((error) => {
        console.error(error);
      })
    }
  }
}

export default withCookies(withRouter(FiltersView));



// WEBPACK FOOTER //
// ./src/views/selection_economic/EconomicSelectionView.js